<template>
<el-drawer :title="title" :visible.sync="visible" size="30%" :append-to-body="true" :wrapperClosable="false">
    <div class="draw-form">
        <el-form :model="form" label-width="100px" label-position="left" style="margin-top:12px;">
            <template v-for="(attr,index) in rules">
                <el-form-item :label="attr.label" :key="index">
                    <el-col :span="14">
                        <el-input v-if="attr.type == 'text'" v-model="addons[attr.field]" :placeholder="attr.label"></el-input>
                        <el-input v-else-if="attr.type == 'number'" v-model="addons[attr.field]" type="number" :placeholder="attr.label"></el-input>
                        <el-date-picker v-else-if="attr.type == 'date'" value-format="yyyy-MM-dd" type="date" :placeholder="attr.label" v-model="addons[attr.field]"></el-date-picker>
                        <el-date-picker v-else-if="attr.type == 'datetime'" type="datetime" value-format="yyyy-MM-dd HH:mm" :placeholder="attr.label" v-model="addons[attr.field]"></el-date-picker>
                        <el-select v-else-if="attr.type == 'select'" v-model="addons[attr.field]" :placeholder="attr.label">
                            <el-option v-for="(item, index2) in former.getCfgItems(attr.content)" :key="index2" :label="former.getItemLabel(item)" :value="former.getItemValue(item)"></el-option>
                        </el-select>
                        <el-checkbox-group v-else-if="attr.type == 'checkbox'" v-model="addons[attr.field]">
                            <el-checkbox v-for="(item, index2) in former.getCfgItems(attr.content)" :key="index2" :label="former.getItemValue(item)">{{former.getItemLabel(item)}}</el-checkbox>
                        </el-checkbox-group>
                        <el-radio-group v-else-if="attr.type == 'radio'" v-model="addons[attr.field]">
                            <el-radio v-for="(item, index2) in former.getCfgItems(attr.content)" :key="index2" :label="former.getItemValue(item)">{{former.getItemLabel(item)}}</el-radio>
                        </el-radio-group>
                    </el-col>
                </el-form-item>
            </template>
            <el-form-item label="备注">
                <el-input type="textarea" v-model="form.remark"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submit">确认添加</el-button>
                <el-button @click="visible = false">取消</el-button>
            </el-form-item>
        </el-form>
        <el-divider content-position="center">审核流程</el-divider>
        <!-- 审核流程 -->
        <div class="confirm-box" v-if="confirmStep.length > 0">
            <confirm-process :stepList="confirmStep" :confirm="confirm"></confirm-process>
        </div>
    </div>

</el-drawer>
</template>

<script>
import former from '@/utils/former.js';
import confirmProcess from '@/components/audit/process'; // 新版审核流程
const form = {
    category_id: 0,
    order_id: 0,
    remark: ''
};

export default {
    components: {
        confirmProcess,
    },
    props: {
        parent: {},
        wedding: {}
    },
    data() {
        return {
            visible: false,
            rules: [],
            title: '',
            form: Object.assign({}, form),
            addons: {},
            rules: {},
            confirm: {},
            confirmStep: [],
            editId: '',
            id: '',
            fourEdit:'',
            order:{}
        };
    },
    beforeCreate() {
        this.former = former;
    },
    methods: {
        showDrawer(demand,order,type) {
            let _this = this;
            _this.visible = true;
            _this.id = demand.id;
            _this.fourEdit = type;
            _this.order= order;
            _this.form = Object.assign({}, form);
            let editUrl = '/api/wedding.four/read';
            let options = {
                id: demand.id
            };
            this.$post(editUrl, options).then(res => {
                let category = res.data.category;
                _this.title = '四大金刚-' + category.title;
                // 格式化规则
                let rules = category.rules;
                rules.forEach(ele => {
                    if (ele.type == "checkbox") {
                        // 应该是重新刷dom的方式
                        _this.$set(_this.addons, ele.field, []);
                    }
                });
                _this.rules = rules;
                this.addons = res.data.row.addons;
                this.form = res.data.row

            })
            _this.getAuditResult()

        },
        submit() {
            let _this = this;
            let url = '/api/wedding.four/edit';
            this.form['addons'] = this.addons;
            this.$post(url, this.form).then(res => {
                if (res.code == '200') {
                    _this.parent.showDrawer(_this.order);
                    _this.visible = false;
                    _this.$message({
                        type: 'success',
                        message: res.msg
                    });

                } else {
                    _this.$message({
                        type: 'danger',
                        message: res.msg
                    });
                }
            })

        },
        // 获取审核流程
        getAuditResult() {
            let _this = this;
            let url = '/api/wedding.four/getAuditResult';
            let params = {
                id: _this.id,
                audit_type:_this.fourEdit//可传可不传 audit_type
            };
            _this.$post(url, params).then(res => {
                if (res.code == 200) {
                    let auditProcess = res.data.process;
                    _this.confirmStep = auditProcess;

                }
            });
        },
    }
}
</script>
